import { useState, useRef } from 'react';
import cn from 'classnames';

import { Checkbox, CheckboxActive } from './Icons/CheckboxIcons';
import InfoIcon from './Icons/InfoIcon';
import PostcodesForm from './PostcodesForm';

import useOnClickOutside from './hooks';

import { eventLog } from './api'

import './Delivery.css';

const Delivery = (props) => {
  const { onChangeDayDelivery, onSetPostcode, isActiveDayDelivery, isPickUp } = props;
  const [ visible, setVisible ] = useState(false)

  const tooltipRef = useRef();

  useOnClickOutside(tooltipRef, () => {
    setVisible(false)
  });

  const handdleClick = (e) => {
    e.stopPropagation();
    setVisible(true);

    eventLog({event_id: 14});
  }

  const handleChange = () => {
    onChangeDayDelivery(!isActiveDayDelivery)
  }

  const renderTooltip = () => (
    <div
      className={cn('rntr-delivery__tooltip', {
        'rntr-delivery__tooltip_pickup': isPickUp
      })}
      ref={ tooltipRef }>
      {
        isPickUp
        ? <p className='rntr-delivery__text'>
              For same-day rental booking, select Pick up in store.
              Please return the rental item in store by 5pm on the return date to avoid late fee.
           </p>
        : <>
          <p className='rntr-delivery__text'>Select same day delivery service to change the booking calendar for available items.</p>
          <p  className='rntr-delivery__text'>Only available in Sydney metro areas (Mon - Fri)</p>
          <p className='rntr-delivery__green-text'>Other metro cities coming soon!</p>
        </>
      }
    </div>
  );

  const buttonClasses = cn('rntr-delivery__button', {
    'rntr-delivery__button_active': isActiveDayDelivery
  })
  return (
    <div className='rntr-delivery'>
      <div className='rntr-delivery__same-day'>
        <div className='rntr-delivery__buttons'>
          <button className={ buttonClasses } type='button' onClick={ handleChange }>
            <span className='rntr-delivery__checkbox'>
              { isActiveDayDelivery ? <CheckboxActive/> : <Checkbox/> }
            </span>
            { isPickUp
            ? <span className='rntr-delivery__label'>PICK UP IN STORE</span>
            : <>
              <span className='rntr-delivery__label'>
                Same day delivery&nbsp;
              </span>
              <span className='rntr-delivery__label-info'>($25 - order before 11 am)</span>
            </> }
          </button>
          <button
            className='rntr-delivery__tooltip-button'
            type='button'
            onClick={ handdleClick }>
            <InfoIcon/>
          </button>
          { visible && renderTooltip() }
        </div>
        {
          !isPickUp &&
          <div className='rntr-delivery__postcodes'>
            <PostcodesForm
              onSetPostcode={ onSetPostcode }/>
          </div>
        }
      </div>
    </div>
  )
}

export default Delivery;
